/**
 * Gestor Login Page
 * Se nao autenticado como master: mostra login
 * Se autenticado: redireciona para /gestor (layout cuida do resto)
 */

import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Button, Input, Card, CardContent, CardHeader, CardTitle, ThemeToggle } from "@payflow/ui";
import { useAuth } from "../contexts/AuthContext";
import { LanguageSelector } from "../components/LanguageSelector";

export function GestorLoginPage() {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary-200 border-t-primary-600" />
      </div>
    );
  }

  // Se autenticado como master, vai pro dashboard
  if (isAuthenticated && user?.nivel === "master") {
    return <Navigate to="/gestor" replace />;
  }

  return <GestorLoginForm />;
}

function GestorLoginForm() {
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const formData = new FormData(e.currentTarget);
    const email = formData.get("email") as string;
    const senha = formData.get("senha") as string;

    try {
      await login(email, senha);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Credenciais invalidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="absolute right-4 top-4 flex items-center gap-2">
        <LanguageSelector />
        <ThemeToggle />
      </div>

      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-xl bg-gradient-primary">
            <span className="text-3xl font-bold text-white">P</span>
          </div>
          <CardTitle className="text-2xl">Gestor Pillar Money</CardTitle>
          <p className="mt-2 text-sm text-muted-foreground">
            Acesso restrito a administracao do SaaS
          </p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              label="Email"
              name="email"
              type="email"
              placeholder="seu@email.com"
              required
            />
            <Input
              label="Senha"
              name="senha"
              type="password"
              placeholder="••••••••"
              required
            />

            {error && (
              <p className="text-sm text-error">{error}</p>
            )}

            <Button type="submit" className="w-full" loading={loading}>
              Entrar
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
